export default function IconJoin(props) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" {...props}>
      <path d="M4 12h16M14 6l6 6-6 6"/>
    </svg>
  )
}
